module.exports = __webpack_public_path__ + "static/media/Tutoriel Édition CSV.5395ae79.pdf";